import { defineComponent as _defineComponent } from 'vue'
import { setBlockTracking as _setBlockTracking, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { IonTitle, IonToolbar, IonHeader, } from '@ionic/vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectStocktakingEntryHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode("WMS | Stocktaking")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _setBlockTracking(1),
    _cache[0]
  )
}
}

})